import { AutogenModelEdiFunctionalAck, AutogenRowEdiFunctionalAck } from "./autogen/AutogenModelEdiFunctionalAck";

export class ModelEdiFunctionalAck extends AutogenModelEdiFunctionalAck<RowEdiFunctionalAck> {
    constructor() {
        super(RowEdiFunctionalAck);
    }
}

export class RowEdiFunctionalAck extends AutogenRowEdiFunctionalAck {
}